import {Component, input, model} from '@angular/core';
import {FilterOption} from '../filter-chips/filter-chips.component';

/** Clickable cards with dot, label and a large count (platform overview). */
@Component({
    selector: 'app-filter-tiles',
    templateUrl: './filter-tiles.component.html',
    styleUrl: './filter-tiles.component.scss',
    host: {
        'role': 'group'
    }
})
export class FilterTilesComponent<T = string> {
    readonly options = input<FilterOption<T>[]>([]);
    readonly value = model<T | null>(null);
}
